module.exports = __webpack_public_path__ + "media/images/expe_vertical.svg-b0fe55eb4d96fed22dc08c522e2c89a9.svg";